import React from 'react';
import { useSearchParams } from 'react-router-dom';

import TabPanel from 'commons/TabPanel';

import TableActivityLogs from '../../Common/TableActivityLogs';
import TableNewArrival from '../../TableCollectorPanel/TableNewArrival';
import TableShowAllRoleCollector from '../../TableCollectorPanel/TableShowAllRoleCollector';
import TableShowSoldDonatedRoleCollector from '../../TableCollectorPanel/TableShowSoldDonatedRoleCollector';

const TableCollector = () => {
  const [searchParams] = useSearchParams();
  const tabValue = Number(searchParams.get('tab') || 0);

  return (
    <>
      <TabPanel
        value={tabValue}
        index={0}
      >
        <TableShowAllRoleCollector />
      </TabPanel>

      <TabPanel
        value={tabValue}
        index={1}
      >
        <TableShowSoldDonatedRoleCollector />
      </TabPanel>

      <TabPanel
        value={tabValue}
        index={2}
      >
        <TableActivityLogs />
      </TabPanel>

      <TabPanel
        value={tabValue}
        index={3}
      >
        <TableNewArrival />
      </TabPanel>
    </>
  );
};

export default TableCollector;
